<div class="modal-body scroll-panel w-100-p h-adjust-px">
    <div class="row mt-2">
        <div class="col-sm-9">
            <div class="flex justify-content-space-between">
                <span class="fw-bold title-modal-detail fz-14-px">
                    {{ 'cae-user.lblUploadUser' | translate }}
                </span>
            </div>
            <div class="line-h-blue-purple-dialogs mt-2 mb-3"></div>

        </div>
        <div class="col-sm-3">
            <p class="fz-11-px">* {{ 'common.lblsAreRequired' | translate }}</p>
        </div>

        <div class="col-md-12 my-3">
            <p> {{ 'cae-user.lblUploadUserInstructions' | translate }}</p>
        </div>

        <div class="col-md-12 my-3">
            <div class="btn-group">
                <button type="button" class="btn btn-primary-05" (click)="onDownload()">
                    <i class="fa-solid fa-download"></i>
                    {{ 'cae-user.btnDownloadTemplate' | translate }}
                </button>
            </div>
        </div>


        <div class="col-md-12 my-1">
            <div class="input-upload-file mb-3">
                <input #fileInput type="file" (change)="onFileSelectedTemplate($event)" hidden
                    accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" />

                <div class="input-fileZip-container">
                    <span class="lbl-input-file" *ngIf="this._templateUsers != null ">{{ this._templateUsers.name
                        }}</span>
                    <span class="lbl-input-file" *ngIf="this._templateUsers == null ">{{ 'cae-user.lblNoFileSelected' |
                        translate}}</span>
                </div>

                <button class="btn btn-none" (click)="fileInput.click()">
                    <i class="ml-4 fa-solid fa-file-arrow-up mr-2 text-secondary">
                    </i>
                </button>
            </div>
        </div>
    </div>

    <div class="row" style="font-size: 0.9em;">

        <div class="col-md-12 my-3">
            <p> {{ 'cae-user.lblInstructionsImages' | translate }}</p>
        </div>

        <div class="col-md-12 fw-bold">
            <span class="d-block mb-1"> {{ 'cae-user.lblInstructionsImages2' | translate }}</span>
            <span class="d-block mb-3"> {{ 'cae-user.lblInstructionsImages3' | translate }}</span>
        </div>

        <div class="col-md-12 my-1">
            <div class="input-upload-file mb-3">
                <input #fileInputZip type="file" (change)="onFileSelected($event)" hidden accept=".zip,.rar,.7zip" />
                <div class="input-fileZip-container">
                    <span class="lbl-input-file" *ngIf="this._folderZip != null ">{{ this._folderZip.name }}</span>
                    <span class="lbl-input-file" *ngIf="this._folderZip == null ">{{ 'cae-user.lblNoFileSelected' |
                        translate}}</span>
                </div>
                <button class="btn btn-none" (click)="fileInputZip.click()">
                    <i class="ml-4 fa-solid fa-file-arrow-up mr-2 text-secondary">
                    </i>
                </button>
            </div>
        </div>
        <div class="col-lg-12 text-lg-right mb-5">
            <p class="fz-11-px"> {{ 'cae-user.lblInstructionsZip' | translate }}</p>
        </div>
    </div>
</div>


<div class="modal-footer">
    <button class="btn btn-secondary " data-dismiss="modal" (click)="onClose(0)">
        {{ 'common.btnCancel' | translate }}
    </button>
    <button class="btn btn-info " type="submit" (click)="onSave()" >
        {{ 'common.btnSave' | translate }}
    </button>
</div>


<ng-container *ngIf="isConfirmationDialog">
    <app-confirmation-dialog [confirmationDialog]="confirmationDialog"
        (onConfirmDialog)="orchestratorCloseDialog($event)"></app-confirmation-dialog>
</ng-container>